import { getAuditUnitWarnings } from "../../../utilities/auditUtilities"
import { lastSix } from "../../../utilities/unitUtilities"
import InfoItem from "../../common/InfoItem"
import AuditUnitWarnings from "./AuditUnitWarnings"

export default function AuditUnitDetails({ auditUnit }) {
  const warnings = getAuditUnitWarnings(auditUnit)

  return (
    <div className="flex flex-col items-start w-full px-2">
      <p className="text-lg text-grey-300">{auditUnit?.attributes?.year} {auditUnit?.attributes?.make}</p>
      <p className= 'text-4xl text-grey-100'>{auditUnit?.attributes?.model}</p>
      <AuditUnitWarnings warnings={warnings} />
      <div className="w-full grid grid-cols-2 lg:grid-cols-3">
        <InfoItem title="Last Six">
          {auditUnit && lastSix(auditUnit?.attributes?.vin)}
        </InfoItem>
        <InfoItem title="Days Floored">
          {auditUnit?.attributes["days-floored"]}
        </InfoItem>
      </div>
    </div>
  )
}